// ─── Recettes — bibliothèque de la fonctionnalité « Repas » ───────────
// Collection plate `recettes`, indexée par espaceId (My Meals — pas de pont
// calendrierId : les recettes ne sont pas l'exception Budget, ce sont des
// données neuves de la suite). Porté de MoPCal-v3 services/recettes.js.
//   { espaceId, nom, categorie?, portions, tempsMin,
//     ingredients: [{ nom, quantite, unite, prix }],   // prix unitaire € (coût)
//     etapes: [string],
//     creePar, creeParNom, creeLe, maj }
import { db } from '@mop/core';
import { collection, query, where, onSnapshot, addDoc, doc, updateDoc, deleteDoc } from 'firebase/firestore';

export function ecouterRecettes(espaceId, callback, onErreur) {
  if (!espaceId) { callback([]); return () => {}; }
  const q = query(collection(db, 'recettes'), where('espaceId', '==', espaceId));
  return onSnapshot(q, (snap) => {
    const liste = snap.docs.map(d => ({ id: d.id, ...d.data() }));
    liste.sort((a, b) => (a.nom || '').localeCompare(b.nom || ''));
    callback(liste);
  }, (e) => { callback([]); onErreur?.(e); });
}

// Normalise les champs d'une recette avant écriture (Firestore rejette undefined).
function nettoyer(r) {
  return {
    nom:       (r.nom || '').trim(),
    categorie: r.categorie || '',
    portions:  Math.max(1, Number(r.portions) || 1),
    tempsMin:  Number(r.tempsMin) || 0,
    ingredients: (r.ingredients || [])
      .filter(i => (i.nom || '').trim())
      .map(i => ({
        nom:      (i.nom || '').trim(),
        quantite: (i.quantite != null ? String(i.quantite) : '').trim(),
        unite:    (i.unite || '').trim(),
        prix:     (i.prix != null && i.prix !== '') ? (Number(i.prix) || 0) : null,
      })),
    etapes: (r.etapes || []).map(s => (s || '').trim()).filter(Boolean),
  };
}

export async function creerRecette({ espaceId, creePar, creeParNom, ...r }) {
  if (!espaceId) throw new Error('Aucun espace actif');
  const data = nettoyer(r);
  if (!data.nom) throw new Error('Donne un nom à la recette.');
  const ref = await addDoc(collection(db, 'recettes'), {
    espaceId, ...data,
    creePar: creePar || null, creeParNom: creeParNom || '',
    creeLe: new Date().toISOString(), maj: new Date().toISOString(),
  });
  return ref.id;
}

export async function modifierRecette(recetteId, r) {
  await updateDoc(doc(db, 'recettes', recetteId), { ...nettoyer(r), maj: new Date().toISOString() });
}

export async function supprimerRecette(recetteId) {
  await deleteDoc(doc(db, 'recettes', recetteId));
}

// Coût estimé d'une recette = somme des prix d'ingrédients renseignés.
export function coutRecette(recette) {
  return (recette?.ingredients || []).reduce((s, i) => s + (Number(i.prix) || 0), 0);
}
